export const areaWithDelay = {
  provinces: [
    {
      province: ''
    },
  ],
  cities: [
    {
      province: '',
      city: ''
    },
  ],
  brgys: [
    {
      province: '',
      city: ''
    },
    // {
    //   province: 'Metro Manila',
    //   city: 'Caloocan City',
    //   brgy: 'Barangay 54',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Las Pinas City',
    //   brgy: 'B.F. International Village',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Bel-Air',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Pio Del Pilar',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Dasmarinas',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Guadalupe Viejo',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'San Lorenzo',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Poblacion',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'San Antonio',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Makati City',
    //   brgy: 'Urdaneta',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Addition Hills',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Barangka Ibaba',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Barangka Ilaya',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Malamig',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Hulo',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'San Jose',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Mandaluyong City',
    //   brgy: 'Wack-Wack Greenhills',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 170',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 355',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 215',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 220',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 428',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 666',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 670',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 673',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 686',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 696',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 703',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Manila',
    //   brgy: 'Barangay 828',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Muntinlupa City',
    //   brgy: 'Alabang',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Muntinlupa City',
    //   brgy: 'Ayala Alabang',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Muntinlupa City',
    //   brgy: 'Cupang',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Paranaque City',
    //   brgy: 'B.F. Homes',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Paranaque City',
    //   brgy: 'Marcelo Green Village',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Paranaque City',
    //   brgy: 'Merville',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Paranaque City',
    //   brgy: 'Moonwalk',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Paranaque City',
    //   brgy: 'San Isidro',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasay City',
    //   brgy: 'Barangay 76',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'Kapitolyo',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'Pinagbuhatan',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'San Antonio',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'San Nicolas',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'Santolan',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Pasig City',
    //   brgy: 'Ugong',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Kristong Hari',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Blue Ridge B',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Ugong Norte',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Immaculate Concepcion',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Dona Imelda',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'Lourdes',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'San Roque',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Quezon City',
    //   brgy: 'South Triangle',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'San Juan City',
    //   brgy: 'Addition Hills',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Taguig City',
    //   brgy: 'Central Signal Village',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Taguig City',
    //   brgy: 'Fort Bonifacio',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Taguig City',
    //   brgy: 'Pinagsama',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Taguig City',
    //   brgy: 'San Miguel',
    // },
    // {
    //   province: 'Metro Manila',
    //   city: 'Taguig City',
    //   brgy: 'Western Bicutan',
    // },
    // {
    //   province: 'Davao Del Norte',
    //   city: 'Island Garden City of Samal',
    //   brgy: 'Camudmud',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Alfonso Angliongto Sr.',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Calinan',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Catalunan Pequeno',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Buhangin',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Mudiang',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Pampanga',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'San Pedro',
    // },
    // {
    //   province: 'Davao Del Sur',
    //   city: 'Davao City',
    //   brgy: 'Toril',
    // },
    // {
    //   province: 'Zamboanga Del Sur',
    //   city: 'Zamboanga City',
    //   brgy: 'Barangay Zone IV',
    // },
    // {
    //   province: 'Benguet',
    //   city: 'Mankayan',
    //   brgy: 'Poblacion',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'Balagtas',
    //   brgy: 'Panginay',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'Baliuag',
    //   brgy: 'Pinagbarilan',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'Marilao',
    //   brgy: 'Loma De Gato',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'Meycauayan City',
    //   brgy: 'Camalig',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'San Miguel',
    //   brgy: 'San Vicente',
    // },
    // {
    //   province: 'Bulacan',
    //   city: 'Santa Maria',
    //   brgy: 'Tumana',
    // },
    // {
    //   province: 'La Union',
    //   city: 'San Fernando City',
    //   brgy: 'Pagdalagan',
    // },
    // {
    //   province: 'La Union',
    //   city: 'San Juan',
    //   brgy: 'Caarusipan',
    // },
    // {
    //   province: 'Pampanga',
    //   city: 'Angeles City',
    //   brgy: 'Santo Domingo',
    // },
    // {
    //   province: 'Pampanga',
    //   city: 'San Fernando City',
    //   brgy: 'Del Pilar',
    // },
    // {
    //   province: 'Pampanga',
    //   city: 'Santo Tomas',
    //   brgy: 'San Matias',
    // },
    // {
    //   province: 'Albay',
    //   city: 'Ligao City',
    //   brgy: 'Santa Cruz',
    // },
    // {
    //   province: 'Batangas',
    //   city: 'Batangas City',
    //   brgy: 'Bolbok',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Bacoor City',
    //   brgy: 'Aniban 1',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Bacoor City',
    //   brgy: 'Molino IV',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Cavite City',
    //   brgy: 'Barangay 40',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Imus City',
    //   brgy: 'Alapan II-A',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Imus City',
    //   brgy: 'Buhay Na Tubig',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Noveleta',
    //   brgy: 'San Antonio I',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Silang',
    //   brgy: 'Inchican',
    // },
    // {
    //   province: 'Cavite',
    //   city: 'Silang',
    //   brgy: 'Puting Kahoy',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Bay',
    //   brgy: 'Santo Domingo',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Binan City',
    //   brgy: 'Loma',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Binan City',
    //   brgy: 'San Francisco',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Cabuyao City',
    //   brgy: 'Banlic',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Calamba City',
    //   brgy: 'Canlubang',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Calamba City',
    //   brgy: 'Lingga',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'San Pablo City',
    //   brgy: 'Santo Angel',
    // },
    // {
    //   province: 'Laguna',
    //   city: 'Santa Rosa City',
    //   brgy: 'Don Jose',
    // },
    // {
    //   province: 'Palawan',
    //   city: 'Coron',
    //   brgy: 'Barangay IV',
    // },
    // {
    //   province: 'Palawan',
    //   city: 'El Nido',
    //   brgy: 'Masagana Pob.',
    // },
    // {
    //   province: 'Quezon',
    //   city: 'Lucena City',
    //   brgy: 'Gulang-Gulang',
    // },
    // {
    //   province: 'Quezon',
    //   city: 'Sariaya',
    //   brgy: 'Mamala Ii',
    // },
    // {
    //   province: 'Rizal',
    //   city: 'Antipolo City',
    //   brgy: 'Cupang',
    // },
    // {
    //   province: 'Rizal',
    //   city: 'Antipolo City',
    //   brgy: 'Mayamot',
    // },
    // {
    //   province: 'Rizal',
    //   city: 'Antipolo City',
    //   brgy: 'San Roque',
    // },
    // {
    //   province: 'Rizal',
    //   city: 'Binangonan',
    //   brgy: 'Palangoy',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Cebu City',
    //   brgy: 'Basak San Nicolas',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Cebu City',
    //   brgy: 'Kamagayan',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Cebu City',
    //   brgy: 'Lahug',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Lapu-Lapu City',
    //   brgy: 'Bankal',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Lapu-Lapu City',
    //   brgy: 'Pajac',
    // },
    // {
    //   province: 'Cebu',
    //   city: 'Talisay City',
    //   brgy: 'Dumlog',
    // },
    // {
    //   province: 'Leyte',
    //   city: 'Palo',
    //   brgy: 'Guindapunan',
    // },
    // {
    //   province: 'Leyte',
    //   city: 'Tacloban City',
    //   brgy: 'Barangay 20',
    // },
  ]
}


/** WEBPACK FOOTER **
 ** ./src/constants/areaWithDelay.js
 **/